import { gql } from 'graphql-request'

export namespace AttachmentQueries {
  export const ATTACHMENT_DETAILS = gql`
    fragment AttachmentDetails on Attachment {
      contentType
      filename
      id
      path
    }
  `
}
